import { useEffect } from 'react';

import { useProfileContext } from '@/features/context/ProfileContext';
import { getCards } from '@/store/actions/profile.actions';

import { useAppSelector, useAppDispatch } from '@/hooks/redux-helpers';

import { selectProfileCardsByUserId } from '@/store/selectors';

export function useUserCardList() {
  const { user } = useProfileContext();
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector((state) => selectProfileCardsByUserId(state, user.userId)?.isLoading);
  const cards = useAppSelector((state) => selectProfileCardsByUserId(state, user.userId))?.state?.map(
    (cards) => cards.state?.card,
  );

  useEffect(() => {
    dispatch(getCards(user.userId));
  }, [dispatch, user.userId]);

  return { isLoading, cards };
}
